import Vue from 'vue'
import { $$ } from '../_utils'

Vue.component('vue-user-activities', {
  template: '#vue-user-activities-template',
  props: { activities: Array },
  data() {
    return {
      titleItems: [],
      itemsToShow: [],
      showedAllItems: false,
    }
  },
  methods: {
    setTitleItems() {
      this.titleItems = this.$props.activities.slice(0, 4)
    },
    setItemsToShow() {
      this.itemsToShow = this.$props.activities.slice(4)
    },
    rotateArrow() {
      if (!this.$refs.arrow.classList.value.includes('rotate'))
        this.$refs.arrow.classList.add('rotate')
      else this.$refs.arrow.classList.remove('rotate')
    },
    onMoreClick() {
      if (this.showedAllItems) {
        this.hideContent()
        this.rotateArrow()
        this.showedAllItems = false
      } else {
        this.rotateArrow()
        this.showContent()
        this.showedAllItems = true
      }
    },
    showContent() {
      this.$refs.content.poinerEvents = 'all'
      const contentHeight = `${this.$refs.content.scrollHeight}px`
      this.$refs.content.style.height = 0
      setTimeout(() => {
        this.$refs.content.style.height = contentHeight
        this.$refs.content.style.opacity = 1
        setTimeout(() => {
          this.$refs.content.style.height = 'auto'
        }, 350)
      }, 100)
    },
    hideContent() {
      const contentHeight = `${this.$refs.content.scrollHeight}px`
      this.$refs.content.style.pointerEvents = 'none'
      this.$refs.content.style.height = contentHeight
      setTimeout(() => {
        this.$refs.content.style.height = 0
        this.$refs.content.style.opacity = 0
      }, 100)
    },
  },
  mounted() {
    this.setTitleItems()
    this.setItemsToShow()
    this.hideContent()
  },
})

const activities = $$('#vue-user-activities-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!activities) return
  activities.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
